var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.form,
            "label-col": _vm.labelCol,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-row",
            { staticClass: "flex-row" },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "所属品系",
                        prop: "strainsNameList",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            gap: "4px",
                            width: "100%",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                mode: "multiple",
                                placeholder: "请选择品系",
                                "collapse-tags": true,
                                disabled: _vm.isDisabled(),
                              },
                              on: { change: _vm.onStrainsChange },
                              model: {
                                value: _vm.form.strainsNameList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "strainsNameList", $$v)
                                },
                                expression: "form.strainsNameList",
                              },
                            },
                            _vm._l(_vm.carStrainsDS, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.strainsCode,
                                  attrs: { value: item.strains },
                                },
                                [_vm._v(_vm._s(item.strains))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#999",
                                "font-size": "12px",
                                "line-height": "1.4",
                              },
                            },
                            [_vm._v(" 注意：公路用车与工程用车不可同时选择 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "地点",
                        prop: "activityPlace",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-cascader", {
                        attrs: {
                          options: _vm.regionOptions,
                          fieldNames: {
                            label: "areaName",
                            value: "areaName",
                            children: "children",
                          },
                          placeholder: "请选择区域",
                          allowClear: "",
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.activityPlace,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "activityPlace", $$v)
                          },
                          expression: "form.activityPlace",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "详细地址",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.addressInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addressInfo", $$v)
                          },
                          expression: "form.addressInfo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "关怀人数",
                        prop: "careNum",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, max: 50, disabled: _vm.isDisabled() },
                        on: { change: _vm.onCareNumChange },
                        model: {
                          value: _vm.form.careNum,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "careNum", $$v)
                          },
                          expression: "form.careNum",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.customerList.length
            ? _c("div", [
                _c("div", { staticClass: "item-line" }, [_vm._v("客户信息")]),
                _c(
                  "div",
                  {
                    staticClass: "filter-container",
                    staticStyle: { padding: "0px 1%" },
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "formBan",
                        attrs: { model: _vm.modelVal, "label-width": "14px" },
                      },
                      [
                        _c(
                          "vxe-table",
                          {
                            ref: "xTable",
                            staticClass: "mytable-scrollbar",
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              border: "",
                              "show-header-overflow": "",
                              "show-overflow": "",
                              "column-config": { resizable: true },
                              stripe: "",
                              round: "",
                              "max-height":
                                _vm.$store.state.app.height - 300 > 200
                                  ? _vm.$store.state.app.height - 200
                                  : 200,
                              "scroll-y": { enabled: false },
                              "row-config": { isHover: true },
                              data: _vm.customerList,
                            },
                          },
                          [
                            _c("vxe-column", {
                              attrs: {
                                type: "seq",
                                title: "序号",
                                width: "60",
                                align: "center",
                              },
                            }),
                            _c("vxe-column", {
                              attrs: { title: "姓名" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: " " } },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                disabled: _vm.isDisabled(),
                                              },
                                              model: {
                                                value: scope.row.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2192417661
                              ),
                            }),
                            _c("vxe-column", {
                              attrs: { title: "底盘号" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: " " } },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                disabled: _vm.isDisabled(),
                                              },
                                              model: {
                                                value: scope.row.chassisNum,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "chassisNum",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.chassisNum",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2520459772
                              ),
                            }),
                            _c("vxe-column", {
                              attrs: { title: "手机号" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: " " } },
                                          [
                                            _c("a-input", {
                                              attrs: {
                                                disabled: _vm.isDisabled(),
                                              },
                                              model: {
                                                value: scope.row.phone,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "phone",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.phone",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1867916870
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "负责人姓名",
                        prop: "headName",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headName", $$v)
                          },
                          expression: "form.headName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "负责人电话",
                        prop: "headName",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: _vm.isDisabled() },
                        model: {
                          value: _vm.form.headPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "headPhone", $$v)
                          },
                          expression: "form.headPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "sign-tiem widthHuo",
                      attrs: {
                        label: "备注",
                        "label-col": { span: 3, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          "auto-size": { minRows: 2, maxRows: 6 },
                          disabled: _vm.isDisabled(),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "item-line" }, [_vm._v("费用信息")]),
          _c(
            "a-row",
            { staticClass: "flex-row" },
            [
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "礼品费",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.giftFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "giftFee", $$v)
                          },
                          expression: "form.giftFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "其他",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: _vm.isDisabled() },
                        on: { change: _vm.gettotalCost },
                        model: {
                          value: _vm.form.otherFee,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "otherFee", $$v)
                          },
                          expression: "form.otherFee",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "合计",
                        "label-col": { span: 4, style: { width: "100px" } },
                      },
                    },
                    [
                      _c("a-input-number", {
                        attrs: { min: 0, disabled: "" },
                        model: {
                          value: _vm.form.totalCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalCost", $$v)
                          },
                          expression: "form.totalCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.approveBtnDisplay === true
            ? _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "label-col": { span: 4, style: { width: "100px" } },
                            label: "经销商已补差",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.dealerDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dealerDiff", $$v)
                              },
                              expression: "form.dealerDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "label-col": { span: 4, style: { width: "100px" } },
                            label: "区域已补差",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.areaDiff,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "areaDiff", $$v)
                              },
                              expression: "form.areaDiff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            "label-col": { span: 4, style: { width: "100px" } },
                            label: "最高支持费用",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.isDisabled() },
                            model: {
                              value: _vm.form.maxSupportFee,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "maxSupportFee", $$v)
                              },
                              expression: "form.maxSupportFee",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }